/* Custom Club homepage: card image sliders + swatches (same as COS collection), tabs.
   Quick-add size buttons use data-ccu-add and are handled by assets/cos-cart.js. */
(function () {
  function initCard(card) {
    if (card.dataset.init) return;
    card.dataset.init = '1';
    var track = card.querySelector('.cosc-track');
    if (!track) return;
    var prev = card.querySelector('.cosc-arrow--prev');
    var next = card.querySelector('.cosc-arrow--next');
    var bar = card.querySelector('.cosc-progress span');
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function update() {
      var n = track.children.length, i = idx();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
      if (bar) bar.style.transform = 'translateX(' + (i * 100) + '%)';
    }
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();
    card.querySelectorAll('.cosc-swatch').forEach(function (s) {
      s.addEventListener('click', function () {
        card.querySelectorAll('.cosc-swatch').forEach(function (x) { x.classList.toggle('is-active', x === s); });
        if (s.dataset.url) card.querySelectorAll('a.cosc-track, .cosc-name a').forEach(function (a) { a.setAttribute('href', s.dataset.url); });
        if (!s.dataset.img) return;
        var img = track.querySelector('.cosc-img');
        if (img) { img.removeAttribute('srcset'); img.src = s.dataset.img; }
        track.scrollTo({ left: 0 });
      });
    });
  }
  function initTabs(root) {
    if (root.dataset.tabs) return;
    root.dataset.tabs = '1';
    var tabs = root.querySelectorAll('.cosh-tab');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        root.querySelectorAll('.cosh-panel').forEach(function (p) { p.hidden = p.dataset.panel !== t.dataset.tab; });
      });
    });
  }
  function init(scope) {
    (scope || document).querySelectorAll('.cosh .cosc-card').forEach(initCard);
    (scope || document).querySelectorAll('[data-cosh-tabs]').forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
